var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBridge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.02035 7.24491L2 8V9.45384L4.65655 8.7897C5.13802 8.66933 5.59521 8.46708 6.00815 8.19179C7.66285 7.08866 9.60705 6.5 11.5958 6.5H12.4042C14.3929 6.5 16.3371 7.08866 17.9918 8.19179C18.4048 8.46708 18.862 8.66933 19.3435 8.7897L22 9.45384V8L18.9796 7.24491C18.3314 7.08284 17.7158 6.81053 17.1598 6.43987C15.7515 5.501 14.0968 5 12.4042 5H11.5958C9.90319 5 8.2485 5.501 6.8402 6.43987C6.28421 6.81053 5.66862 7.08284 5.02035 7.24491Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11L5.02035 10.2449C5.66862 10.0828 6.28421 9.81053 6.8402 9.43987C8.2485 8.501 9.90319 8 11.5958 8H12.4042C14.0968 8 15.7515 8.501 17.1598 9.43987C17.7158 9.81053 18.3314 10.0828 18.9796 10.2449L22 11V19H15C14.4477 19 14 18.5523 14 18C14 17.4477 14.4477 17 15 17H16.9695C16.9896 16.8358 17 16.669 17 16.5C17 14.0147 14.7614 13 12 13C9.23858 13 7 14.0147 7 16.5C7 16.669 7.01035 16.8358 7.03052 17H9C9.55228 17 10 17.4477 10 18C10 18.5523 9.55228 19 9 19H2V11Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridge);
export default __webpack_public_path__ + "static/media/bridge.0186807db9ff4be0c5d976d1b98fb597.svg";
export { ForwardRef as ReactComponent };